import { Environment, EnvironmentVariables } from '@env/types'

export const environment: EnvironmentVariables = {
    productionMode: true,
    name: Environment.Acceptance,

    api: {
        clientId: '2',
        clientSecret: '2o3sF2uoTdp2fDDV1ol3jSV54fmngtZKNBrRf8Tg',
        schema: 'https',
        hostname: 'api.acc.joinprogram.pwstaging.tech',
        acceptVersionRange: '>=3.34.3 <5.0.0',
    },

    pubsub: {
        schema: 'wss',
        hostname: 'v2.pubsub.acc.joinprogram.pwstaging.tech',
    },
}
